export default interface Season {
  id: number;
  programId: number;
  name: string;
  zipCode?: string;
  country?: string;
  timezone?: string;
  sport?: string;
  tsDivisionId?: number;
  isArchived: boolean;
  type: ActivitySeasonType;
}

/**
 * Enum representation of activity/season types. This list will grow as
 * organizations support all the types of program offerings for an org
 */
export enum ActivitySeasonType {
  LegacyOrgSeason = 'legacy_org_season' /* old style season where has entire org structure */,
  ClubSeason = 'club_season',
  LegacyClubAndLeague = 'legacy_club_and_league',
}
